import MapAdapter from "./modules/MapAdapter";
import GoogleMapsAPI from "./modules/GoogleMapsAPI";
import Location from "./modules/Location";

const { apiKey, locations } = window.MAP;
const { themeURL } = window.WP_VARS;

console.log('test');
console.log('Locations data:', locations);


const mapContainer = document.querySelector(".location-finder__map-container");
const mapElement = document.getElementById("gmap-container");
const searchForm = document.querySelector(".location-finder__form");
const distanceInput = document.querySelector("#max-distace-away-input");
const currentLocationBtn = document.querySelector("#current-location-btn");
const locationListEl = document.querySelector(".location-finder__location-list");
const loadMoreButtonTemplate = document
    .querySelector("#load-more-button")
    .content.firstElementChild;
const searchLocationsButton = document.querySelector("#search-locations-button");

// center of the US mainland
const center = {
    lat: 39.8097343,
    lng: -98.555619,
};

/* -------------------------------------------------------------------------- */
/*                             Safari Focus Fixes                             */
/* -------------------------------------------------------------------------- */
distanceInput.addEventListener("blur", () => {
    searchLocationsButton.focus();
});

searchLocationsButton.addEventListener("blur", () => {
    currentLocationBtn.focus();
});

/* -------------------------------------------------------------------------- */
/*                                     Map                                    */
/* -------------------------------------------------------------------------- */

const markers = [];
let visibleLocationsCursor = 0;
let loadMoreItem = null;
let focusedLocation = null;

const setFocusedLocation = (mapLocation) => {
    if (focusedLocation) {
        focusedLocation.closeInfoWindow();
        focusedLocation.unFocusListItem();
    }
    focusedLocation = mapLocation;
    focusedLocation.focusListItem();
    focusedLocation.openInfoWindow();
};

const startLoading = () => {
    mapContainer.classList.add("location-finder__map-container--loading");
};

const stopLoading = () => {
    mapContainer.classList.remove("location-finder__map-container--loading");
};

const emptyLocationList = () => {
    locationListEl.innerHTML = "";
};

const sortLocationsByDistance = (locations) => {
    return locations.sort((locationA, locationB) => {
        // First, prioritize locations with ischedule_url
        const hasScheduleA = locationA._ischedule_url ? 1 : 0;
        const hasScheduleB = locationB._ischedule_url ? 1 : 0;
        
        // If one has ischedule_url and the other doesn't, prioritize the one with it
        if (hasScheduleA !== hasScheduleB) {
            return hasScheduleB - hasScheduleA; // locations with ischedule_url come first
        }
        
        // If both have the same ischedule_url status, sort by distance
        return parseFloat(locationA.distance) > parseFloat(locationB.distance) ? 1 : -1;
    });
};

const renderLocations = (locations) => {
    const locationElements = locations.map((l) => l.getView());

    emptyLocationList();
    locationListEl.prepend(...locationElements);
    visibleLocationsCursor = 0;
    loadMoreLocations();
    locationListEl.scrollTo({ top: 0, behavior: "smooth" });
};

const generateLoadMoreButton = () => {
    if (loadMoreItem) {
        loadMoreItem.remove();
        loadMoreItem = null;
    }

    const itemEl = loadMoreButtonTemplate.cloneNode(true);
    const buttonEl = itemEl.querySelector(".button");
    buttonEl.addEventListener("click", loadMoreLocations);
    locationListEl.append(itemEl);

    loadMoreItem = itemEl;
};

const loadMoreLocations = () => {
    let itemsShown = 0;
    for (let i = visibleLocationsCursor; i < locationListEl.children.length; i++) {
        const child = locationListEl.children.item(i);

        if (child.classList.contains("location-finder__load-more-item")) {
            continue;
        }

        if (itemsShown < 8) {
            child.classList.add("location-finder__location-item--visible");
            itemsShown++;
        } else {
            break;
        }
    }

    visibleLocationsCursor += itemsShown;

    let totalVisibleItems = 0;
    let totalLocations = 0;
    for (let i = 0; i < locationListEl.children.length; i++) {
        const child = locationListEl.children.item(i);
        if (child.classList.contains("location-finder__location-item--visible")) {
            totalVisibleItems++;
        }
        if (!child.classList.contains("location-finder__load-more-item")) {
            totalLocations++;
        }
    }

    if (totalVisibleItems >= totalLocations) {
        if (loadMoreItem) {
            loadMoreItem.remove();
            loadMoreItem = null;
        }
    } else {
        generateLoadMoreButton();
    }
};

const findClosestMarkers = (coordinates, maxDistance, mapApi) => {
    emptyLocationList();

    const activeLocations = [];

    markers.forEach((m) => {
        const latLng = new google.maps.LatLng(m.coordinates.lat, m.coordinates.lng);
        const distance = mapApi.distanceBetween(latLng, coordinates);
        if (distance <= maxDistance) {
            m.distance = distance;
            m.activate();
            activeLocations.push(m);
        } else {
            m.deactivate();
        }
    });

    const sortedLocations = sortLocationsByDistance(activeLocations);
    renderLocations(sortedLocations);
    return activeLocations;
};

const getUserLocation = async () =>
    new Promise((resolve, reject) => {
        const storedLocaton = localStorage.getItem("location");
        if (storedLocaton) return resolve(JSON.parse(storedLocaton));
        if (!navigator.geolocation)
            reject(new Error("Geolocation is not supported by this browser."));
        navigator.geolocation.getCurrentPosition(
            ({ coords }) => {
                const { latitude, longitude } = coords;
                localStorage.setItem("location", JSON.stringify({ latitude, longitude }));
                return resolve(coords);
            },
            (e) => reject(e)
        );
    });

window.initMap = () => {
    const mapApi = new GoogleMapsAPI(apiKey);
    const map = new MapAdapter({ container: mapElement, center, zoom: 5 });
    map.init();

    const fitBounds = (activeLocations) => {
        const bounds = new google.maps.LatLngBounds();
        for (let i = 0; i < activeLocations.length; i++) {
            bounds.extend(activeLocations[i].marker.getPosition());
        }
        map.getInstance().setCenter(bounds.getCenter());
        map.getInstance().fitBounds(bounds);
    };

    // Create a standard Google Maps marker
    const createMarker = (coordinates, mapInstance, onClick) => {
        const marker = new google.maps.Marker({
            position: {
                lat: parseFloat(coordinates.lat),
                lng: parseFloat(coordinates.lng),
            },
            map: mapInstance, // Initially show marker
        });

        if (onClick) {
            marker.addListener('click', onClick);
        }

        return {
            marker,
            getInstance() {
                return marker;
            },
            activate() {
                marker.setMap(mapInstance);
            },
            deactivate() {
                marker.setMap(null);
            },
            get coordinates() {
                return {
                    lat: parseFloat(coordinates.lat),
                    lng: parseFloat(coordinates.lng)
                };
            }
        };
    };

    // process locations
    locations.forEach((data) => {
        const locationItem = new Location({
            ...data,
            map: map.getInstance(),
        });

        locationItem.infoWindow = new google.maps.InfoWindow({
            content: locationItem.getPopupView(),
        });

        const markerObj = createMarker(data.coordinates, map.getInstance(), () => {
            setFocusedLocation(locationItem);
        });

        locationItem.marker = markerObj.getInstance();

        locationItem.onListItemClick(() => {
            setFocusedLocation(locationItem);
            map.getInstance().setZoom(13);
            map.getInstance().setCenter(markerObj.getInstance().getPosition());
        });

        locationItem.activate = () => markerObj.activate();
        locationItem.deactivate = () => markerObj.deactivate();
        // Use a different property name here:
        locationItem.markerCoordinates = markerObj.coordinates;
        
        markers.push(locationItem);

    });

    const updateMapWithUserLocation = async () => {
        setTimeout(() => {
            if (!localStorage.getItem("location")) {
                stopLoading();
            }
        }, 4000);

        startLoading();
        const { latitude, longitude } = await getUserLocation();
        const latLng = new google.maps.LatLng(latitude, longitude);

        fitBounds(findClosestMarkers(latLng, parseInt(distanceInput.value), mapApi));
        stopLoading();
    };

    currentLocationBtn.addEventListener("click", updateMapWithUserLocation);

    searchForm.addEventListener("submit", async (e) => {
        e.preventDefault();
        const zip = e.target.elements.zip.value;
        const maxDistance = parseInt(e.target.elements.distance.value);
        const results = await mapApi.geocodeAddress(zip + ", USA");
        const coordinates = results[0].geometry.location;
        fitBounds(findClosestMarkers(coordinates, maxDistance, mapApi));
    });

    // Initial load with user location
    updateMapWithUserLocation();
};
